import { render, staticRenderFns } from "./CategoryListView.vue?vue&type=template&id=5bf6ce86"
import script from "./CategoryListView.vue?vue&type=script&lang=js"
export * from "./CategoryListView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports